var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.image),expression:"image"}],staticClass:"image",attrs:{"alt":"Category Header Image"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }